/**
 * Mensagens cerimoniais para os dois loaders fakes do fluxo:
 *  - Validação do registro (Register → Review)
 *  - Mint na blockchain (Review → Success)
 *
 * Tom: cerimonial + futebol + emoção. Sem cripto, sem jargão técnico,
 * sem mencionar "inteligência artificial".
 */

export const VALIDATION_MESSAGES: string[] = [
  'Conferindo cada detalhe do seu registro…',
  'Garantindo que está dentro das quatro linhas…',
  'Olhando a sua foto com calma…',
  'Lendo a sua frase palavra por palavra…',
  'Aplicando a lei do jogo limpo…',
  'Conferindo se a sua presença está em ordem…',
  'Passando pelo último carimbo cerimonial…',
  'Garantindo que tudo está nos conformes…',
];

export const BLOCKCHAIN_MINT_MESSAGES: string[] = [
  'Cravando seu nome na taça…',
  'Aplicando o selo eterno…',
  'Levantando a taça com a sua presença dentro…',
  'Gravando sua frase para sempre…',
  'Sincronizando com a rede da memória…',
  'Aguardando os carimbos cerimoniais…',
  'Carimbando seu lugar na história…',
  'Selando sua presença na pedra digital…',
];
